import {Component, output, ChangeDetectionStrategy} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {VwuiAngularModule} from '@bvgo-ict/vwui-angular';

@Component({
    selector: 'app-back-header',
    templateUrl: './back-header.component.html',
    styleUrls: ['./back-header.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe, VwuiAngularModule]
})
export class BackHeaderComponent {
    public readonly back = output<void>();
}
